import usdt from '@/assets/image/chains/usdt.png'
import bsc from '@/assets/image/chains/bsc-network.webp'
import arb from '@/assets/image/chains/arbitrum-network.webp'
import polygon from '@/assets/image/chains/polygon-network.webp'
import ethereum from '@/assets/image/chains/ethereum-network.webp'
import usdc from '@/assets/image/chains/usdc.png'
import solana from '@/assets/image/chains/solana.png'
import alipay from '@/assets/image/chains/alipay.webp'
import unionpay from '@/assets/image/chains/unionpay.webp'

export function useCrypto() {
  const currencyIcon: any = {
    USDT: usdt,
    ETH: ethereum,
    USDC: usdc,
    SOL: solana,
    ALIPAY: alipay,
    UNIONPAY: unionpay,
  }
  const networkMap = [
    {
      network: 'BNB Chain',
      alchemyNetwork: 'BSC',
      shortName: 'BSC',
      icon: bsc,
    },
    {
      network: 'Arbitrum One',
      alchemyNetwork: 'ARBITRUM',
      shortName: 'ARB',
      icon: arb,
    },
    {
      network: 'Polygon',
      alchemyNetwork: '',
      shortName: 'POL',
      icon: polygon,
    },
    {
      network: 'Ethereum',
      alchemyNetwork: 'ETH',
      shortName: 'ETH',
      icon: ethereum,
    },
  ]

  // 币种单位
  enum CURRENCY {
    'ETH',
    'USD',
    '',
    'USDT',
    'USDC',
    'SOL',
  }

  return {
    currencyIcon,
    networkMap,
    CURRENCY,
  }
}
